export enum ConformityDeclarationType {
    Excel = 1,
    Pdf = 2,
    PdfDetailed = 3,
    PdfSpecification = 4
}

(ConformityDeclarationType as any).__typeName = 'ConformityDeclarationType';
